var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-list-item",on:{"click":function($event){$event.preventDefault();return _vm.selectVideo.apply(null, arguments)}}},[_c('div',{staticClass:"video-list-item__image",style:({
      backgroundImage: `url(https://img.youtube.com/vi/${_vm.videoItem.youtubeId}/sddefault.jpg)`,
    })}),_c('div',{staticClass:"video-list-item__content"},[_c('div',{staticClass:"video-list-item__title"},[_vm._v(" "+_vm._s(_vm.videoItem.title)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }